import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinmumbai() {



    const cardData = {

keyword: "Mini Bus on Rent in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mini Bus on Rent in Mumbai for corporate events, family functions, weddings, school trips, group tours, airport transfers, pilgrimage journeys, and outstation travel. Our well-maintained mini buses provide comfortable seating, spacious interiors, ample luggage capacity, air-conditioning, and professional chauffeurs to ensure a smooth travel experience. With 24x7 availability, transparent pricing, doorstep pickup and drop, and flexible rental packages, we deliver safe, comfortable, and hassle-free transportation solutions for groups of all sizes across Mumbai and long-distance destinations.",

topPlaces: [
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most visited pilgrimage destinations and attracts thousands of devotees every day. Mini bus rentals are ideal for large families, religious groups, and community tours traveling together comfortably from Mumbai while enjoying a safe and convenient journey with ample seating and luggage space."
    },
    {
        title: "Ajanta & Ellora Caves",
        description:
            "Ajanta and Ellora Caves are world-famous UNESCO World Heritage Sites known for their extraordinary rock-cut architecture, ancient sculptures, and historical significance. Mini buses provide an excellent transportation option for educational tours, family groups, and heritage travelers visiting these remarkable destinations from Mumbai."
    },
    {
        title: "Goa",
        description:
            "Goa remains one of the most popular group travel destinations for beaches, nightlife, water sports, and holiday experiences. Mini bus rentals are perfect for corporate outings, college groups, family vacations, and friends traveling together comfortably on long-distance routes from Mumbai."
    },
    {
        title: "Udaipur",
        description:
            "Known as the City of Lakes, Udaipur is famous for royal palaces, heritage architecture, scenic lakes, and cultural attractions. Group travelers frequently hire mini buses for comfortable sightseeing tours and extended Rajasthan vacations from Mumbai."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlingas and an important pilgrimage destination surrounded by the scenic Sahyadri hills. Mini buses are widely booked by devotional groups seeking a comfortable and organized spiritual journey from Mumbai."
    },
    {
        title: "Ganpatipule",
        description:
            "Ganpatipule is a beautiful coastal destination combining spiritual importance with natural beauty. Known for its famous Ganpati Temple and pristine beach, it is an excellent choice for family groups and religious tours traveling together in a mini bus."
    },
    {
        title: "Mount Abu",
        description:
            "Mount Abu is Rajasthan's only hill station and offers pleasant weather, beautiful viewpoints, lakes, and temples. Mini bus rentals are highly suitable for large family vacations and sightseeing groups looking for comfortable long-distance travel."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for the revered Mahalaxmi Temple, rich cultural heritage, and famous cuisine. Pilgrimage groups, family travelers, and tourists often choose mini buses for a convenient and enjoyable road trip from Mumbai."
    },
    {
        title: "Rann of Kutch",
        description:
            "The White Rann of Kutch is a spectacular destination famous for its endless salt desert, cultural experiences, and seasonal festivals. Mini buses provide the ideal transportation solution for large groups exploring this unique region together."
    },
    {
        title: "Tirupati",
        description:
            "Tirupati is one of the most important pilgrimage destinations in India and attracts devotees from across the country. Mini bus rentals offer a comfortable and cost-effective option for religious groups and families undertaking this long-distance spiritual journey from Mumbai."
    }
],



services: [
{
name: "Mini Bus on Rent in Mumbai",
description: "Mumbai Airport Cab offers Mini Bus on Rent in Mumbai service for comfortable, safe, and affordable group transportation across Mumbai and outstation destinations. Our well-maintained mini buses are ideal for corporate travel, family tours, wedding transportation, airport transfers, school excursions, religious tours, sightseeing trips, business events, and holiday packages. Equipped with comfortable seating, spacious interiors, ample luggage space, air-conditioning, and professional chauffeurs, our mini buses provide a convenient travel solution for medium-sized groups. With transparent pricing, flexible travel schedules, doorstep pickup and drop service, and 24x7 customer support, we ensure every journey is organized, comfortable, and hassle-free. Whether you require transportation for a single day, weekend getaway, or extended tour, our mini bus rental service delivers reliability, convenience, and excellent travel comfort."
},
{
name: "Mumbai Mini Bus Rental",
description: "Mumbai Airport Cab provides Mumbai Mini Bus Rental service with clean, spacious, and professionally maintained vehicles suitable for family gatherings, business travel, corporate events, educational tours, airport transfers, wedding functions, and sightseeing trips. Our mini buses offer comfortable seating arrangements, luggage storage, air-conditioned interiors, and experienced chauffeur service to ensure a smooth travel experience. We focus on safety, punctuality, customer satisfaction, and flexible travel planning while delivering dependable transportation solutions for groups travelling within Mumbai and across major destinations."
},
{
name: "Hire Mini Bus Mumbai",
description: "Hire Mini Bus Mumbai through Mumbai Airport Cab for reliable group transportation tailored to corporate teams, families, tourists, educational institutions, wedding guests, and social gatherings. Our spacious mini buses are designed to provide comfortable seating, efficient travel, and professional service for local travel, outstation journeys, airport transfers, and special events. With transparent pricing, easy booking procedures, and dedicated customer support, we make group transportation simple, convenient, and affordable."
},
{
name: "Mumbai Group Travel Bus",
description: "Mumbai Group Travel Bus service by Mumbai Airport Cab is designed for groups requiring comfortable and coordinated transportation for tours, events, business travel, family functions, school trips, airport transfers, and holiday packages. Our mini buses provide spacious seating, comfortable interiors, professional drivers, and reliable service to ensure passengers enjoy safe and pleasant travel experiences. We offer flexible itineraries, punctual service, and customized transportation plans for every group requirement."
},
{
name: "Mini Bus Booking Mumbai",
description: "Mumbai Airport Cab offers Mini Bus Booking Mumbai with easy reservation processes, instant confirmation, flexible scheduling, and dedicated customer assistance. Whether you need transportation for a wedding, business event, family gathering, sightseeing tour, educational excursion, or airport transfer, our mini buses provide a dependable and comfortable solution. We maintain high standards of vehicle quality, safety, and customer service to ensure a seamless booking and travel experience."
},
{
name: "Mumbai Tourist Mini Bus",
description: "Mumbai Tourist Mini Bus service provides comfortable transportation for sightseeing tours, holiday packages, city excursions, pilgrimage journeys, and group vacations. Mumbai Airport Cab offers spacious mini buses equipped with comfortable seating, air-conditioning, luggage space, and professional chauffeurs familiar with major tourist attractions. We help travellers explore destinations conveniently while ensuring safe, enjoyable, and memorable travel experiences throughout the journey."
},
{
name: "Wedding Mini Bus Mumbai",
description: "Wedding Mini Bus Mumbai service offers organized transportation for wedding guests, family members, relatives, and event attendees. Mumbai Airport Cab provides spacious and comfortable mini buses that simplify group transportation while ensuring timely arrivals and departures for ceremonies, receptions, and wedding functions. Our professional chauffeurs, clean vehicles, flexible travel plans, and reliable service help create smooth and stress-free event transportation experiences."
},
{
name: "20 Seater Mini Bus Mumbai",
description: "Mumbai Airport Cab provides 20 Seater Mini Bus Mumbai service for small and medium-sized groups travelling for family outings, corporate events, educational tours, airport transfers, sightseeing trips, and social functions. Our vehicles feature comfortable seating, air-conditioned interiors, luggage space, and experienced drivers who prioritize passenger safety and convenience. We ensure reliable, affordable, and comfortable transportation for every journey."
},
{
name: "25 Seater Mini Bus Mumbai",
description: "25 Seater Mini Bus Mumbai service is ideal for larger groups requiring spacious and comfortable transportation for weddings, corporate outings, pilgrimage tours, educational trips, family vacations, and event travel. Mumbai Airport Cab offers professionally maintained vehicles with comfortable seating arrangements, ample luggage storage, air-conditioning, and experienced chauffeurs. We provide dependable travel solutions designed to maximize passenger comfort and convenience."
},
{
name: "Mini Bus Corporate Hire Mumbai",
description: "Mumbai Airport Cab offers Mini Bus Corporate Hire Mumbai service for employee transportation, office events, conferences, team outings, business meetings, airport transfers, and executive travel requirements. Our mini buses provide comfortable seating, professional chauffeur service, punctual operations, and efficient transportation management. We help organizations coordinate group travel smoothly while maintaining high standards of safety, reliability, and professionalism."
},
{
name: "Mini Bus Airport Transfer Mumbai",
description: "Mini Bus Airport Transfer Mumbai service provides convenient transportation for groups travelling to and from Mumbai's domestic and international airport terminals. Mumbai Airport Cab offers spacious mini buses with luggage capacity, experienced chauffeurs, flight schedule monitoring, and timely pickup and drop facilities. We ensure comfortable airport transportation for tourists, families, corporate groups, wedding parties, and event attendees."
},
{
name: "Mini Bus Family Trip Mumbai",
description: "Mumbai Airport Cab provides Mini Bus Family Trip Mumbai service for large families planning vacations, religious tours, sightseeing excursions, destination weddings, and weekend holidays. Our spacious mini buses offer comfortable seating, luggage space, air-conditioned travel, and professional driver support. We focus on delivering safe, enjoyable, and memorable travel experiences while ensuring convenience and comfort for every family member."
},
{
name: "Mini Bus Outstation Mumbai",
description: "Book Mini Bus Outstation Mumbai with Mumbai Airport Cab for comfortable travel to destinations such as Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, Aurangabad, and other tourist locations. Our mini buses are designed for long-distance travel with comfortable seating, luggage storage, air-conditioning, and experienced chauffeurs. We provide customized itineraries, transparent pricing, and dependable transportation support for groups travelling beyond Mumbai."
},
{
name: "Mini Bus Tour Package Mumbai",
description: "Mini Bus Tour Package Mumbai service offers customized travel solutions for sightseeing tours, pilgrimage journeys, holiday packages, beach trips, hill station tours, cultural excursions, and group vacations. Mumbai Airport Cab provides comfortable mini buses, professional chauffeurs, flexible itineraries, and complete travel support to ensure passengers enjoy organized and memorable travel experiences. We help groups explore destinations comfortably while maintaining high standards of safety and service."
},
{
name: "Mini Bus One Day Hire Mumbai",
description: "Mumbai Airport Cab offers Mini Bus One Day Hire Mumbai service for customers requiring group transportation for business activities, sightseeing tours, family functions, educational trips, social gatherings, weddings, and special events. Our well-maintained mini buses, experienced drivers, and flexible travel schedules ensure comfortable and efficient transportation throughout the day. We provide dependable service, transparent pricing, and customer-focused travel solutions."
},
{
name: "Mini Bus School Trip Mumbai",
description: "Mini Bus School Trip Mumbai service provides safe and organized transportation for educational excursions, school events, college tours, industrial visits, sports competitions, and academic travel. Mumbai Airport Cab offers comfortable mini buses operated by experienced drivers who prioritize passenger safety and responsible transportation. Our reliable service, punctual schedules, and professionally maintained vehicles make us a trusted choice for educational institutions."
},
{
name: "Mini Bus Event Transport Mumbai",
description: "Mumbai Airport Cab provides Mini Bus Event Transport Mumbai service for conferences, exhibitions, concerts, weddings, private celebrations, corporate functions, and social events. Our spacious mini buses help organizers manage guest transportation efficiently while ensuring comfort, punctuality, and convenience. With professional chauffeurs, flexible scheduling, and dependable service, we support successful event transportation for groups of all sizes."
},
{
name: "Mini Bus Round Trip Mumbai",
description: "Mini Bus Round Trip Mumbai service offers convenient return transportation for family vacations, corporate outings, pilgrimage tours, sightseeing excursions, educational trips, wedding functions, and group events. Mumbai Airport Cab provides spacious vehicles, experienced chauffeurs, transparent pricing, and flexible travel plans. We ensure passengers enjoy safe, comfortable, and hassle-free transportation throughout the entire round-trip journey while maintaining exceptional service standards."
}
],

tableData: [
["Mini Bus on Rent in Mumbai","Mumbai Mini Bus Rental"],
["Hire Mini Bus Mumbai","Mumbai Group Travel Bus"],
["Mini Bus Booking Mumbai","Mumbai Tourist Mini Bus"],
["Wedding Mini Bus Mumbai","20 Seater Mini Bus Mumbai"],
["25 Seater Mini Bus Mumbai","Mini Bus Corporate Hire Mumbai"],
["Mini Bus Airport Transfer Mumbai","Mini Bus Family Trip Mumbai"],
["Mini Bus Outstation Mumbai","Mini Bus Tour Package Mumbai"],
["Mini Bus One Day Hire Mumbai","Mini Bus School Trip Mumbai"],
["Mini Bus Event Transport Mumbai","Mini Bus Round Trip Mumbai"]
],


whychoose: [
    {
        WhyChooseheading: "Reliable Mini Bus on Rent in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mini Bus Rental Services in Mumbai for family tours, corporate events, airport transfers, school trips, weddings, and group transportation requirements."
    },
    {
        WhyChooseheading: "Perfect for Group Travel and Events",
        WhyChoosedescription: "Mini buses are ideal for transporting groups comfortably while ensuring everyone travels together safely and conveniently."
    },
    {
        WhyChooseheading: "Comfortable Seating and Spacious Interiors",
        WhyChoosedescription: "Our mini buses offer comfortable seating arrangements, ample legroom, luggage space, and a smooth travel experience for short and long-distance journeys."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Trips",
        WhyChoosedescription: "Customers can hire mini buses for Mumbai city travel as well as destinations like Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, and other tourist locations."
    },
    {
        WhyChooseheading: "Ideal for Corporate and Employee Transportation",
        WhyChoosedescription: "Many organizations use our mini bus services for employee transport, corporate outings, conferences, team-building events, and business travel."
    },
    {
        WhyChooseheading: "Airport Transfer Services for Groups",
        WhyChoosedescription: "We provide mini bus airport transfers for families, tourist groups, wedding guests, and corporate teams arriving at or departing from Mumbai Airport."
    },
    {
        WhyChooseheading: "Experienced Drivers and Safe Journeys",
        WhyChoosedescription: "Our professional drivers ensure safe travel, punctual service, route expertise, and a comfortable journey throughout the trip."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Booking",
        WhyChoosedescription: "Customers can choose one-way travel, round trips, multi-day tours, sightseeing packages, and customized travel itineraries according to their requirements."
    }
]
};

const faqData = [
    {
        question: "Why choose a Mini Bus on Rent in Mumbai?",
        answer: "Mini buses provide comfortable group transportation with spacious seating, luggage space, and cost-effective travel for families, companies, and tour groups."
    },
    {
        question: "Can I book a mini bus for Mumbai Airport transfers?",
        answer: "Yes, mini buses are available for airport pickup and drop services for groups, families, wedding guests, and corporate teams."
    },
    {
        question: "Is mini bus rental available for outstation travel?",
        answer: "Yes, customers can hire mini buses for Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Lonavala, Ahmedabad, and many other destinations."
    },
    {
        question: "Can mini buses be booked for corporate events?",
        answer: "Yes, mini buses are frequently used for employee transportation, conferences, seminars, corporate outings, and business travel."
    },
    {
        question: "Do you provide mini buses for weddings and family functions?",
        answer: "Yes, mini bus rentals are available for weddings, receptions, family gatherings, and special events."
    },
    {
        question: "Are chauffeur-driven mini buses available?",
        answer: "Yes, all mini bus rentals include experienced and professional drivers."
    },
    {
        question: "Can I book a mini bus for Mumbai sightseeing?",
        answer: "Yes, customers can hire mini buses for Mumbai Darshan, group tours, educational trips, and customized sightseeing itineraries."
    },
    {
        question: "Is advance booking recommended for mini bus rentals?",
        answer: "Yes, advance booking helps secure vehicle availability, especially during holidays, wedding seasons, and peak travel periods."
    },
    {
        question: "Do you provide one-way and round-trip mini bus services?",
        answer: "Yes, one-way transportation, round trips, multi-day tours, and customized travel packages are available."
    },
    {
        question: "How can I book a Mini Bus on Rent in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahesh Chavan",
        feedback:
            "We hired a mini bus for a corporate outing and the experience was excellent. The vehicle was spacious, comfortable, and the driver managed the trip professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rupal Doshi",
        feedback:
            "Our family group booked a mini bus for an outstation tour and everything was perfectly organized. The bus was clean, comfortable, and made the journey enjoyable for everyone.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mini Bus on Rent in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/mini-bus-on-rent-mumbai.jpg",
"description": "Book mini bus on rent in Mumbai for group travel, corporate trips, weddings, tours, and family outings. Mumbai Airport Cabs offers 20 to 25 seater mini buses with professional drivers, comfortable seating, and reliable 24x7 transport service.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mini-bus-on-rent-in-mumbai"
}
};







    return (
        <div>


<Helmet>
  <title>Mini Bus on Rent in Mumbai | Group Travel Bus Hire | +91 9545731161</title>

<meta
 name="description"
 content="Book mini bus on rent in Mumbai for group travel, weddings, corporate tours, and family trips. 20–25 seater comfortable buses with professional drivers and 24x7 service."
/>

<meta
 name="keywords"
 content="mini bus on rent in mumbai, mumbai mini bus rental, hire mini bus mumbai, mumbai group travel bus, mini bus booking mumbai, mumbai tourist mini bus, wedding mini bus mumbai, 20 seater mini bus mumbai, 25 seater mini bus mumbai, mini bus corporate hire mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusonrentinmumbai;